<template>
  <div>
    <el-row class="title-bar" type="flex" justify="space-between">
      <div class="vertical-center-box">
        <div class="title-h3 mr-r15">결과 목록</div>
      </div>
      <div class="vertical-center-box" align="right">
        <el-button size="small" class="mr-r4" @click="onClickExportExcel"><img src="@/assets/img/icons/excel.png" style="position:relative;top:3px;left:-2px">  엑셀출력</el-button>
        <w-header-search-button @click="showSearchTool = !showSearchTool"></w-header-search-button>
      </div>
    </el-row>
    <el-table-wrapper ref="table" :column-default="columnDefault" :data="tableData" :columns="tableColumns" :show-search-tool="showSearchTool" :show-custom-header="true" remote pagination :total="total" @condition-change="loadData">
      <template slot-scope="scope" slot="result-slot">
        <span><i class="icon-dot" :style="{ backgroundColor: colorObject[scope.row.resultStatus] }"></i></span>
      </template>
      <template slot-scope="scope" slot="change-slot">
        <span><i class="fas fa-check" :style="{ color: changeFlagColorObject[scope.row.changeFlag] }"></i></span>
      </template>
      <template slot-scope="scope" slot="detail-slot">
          <span><i class="far fa-search-plus c-pointer" @click.stop="onClickDetailButton(scope.row)"></i></span>
        </template>
    </el-table-wrapper>
    <w-execution-result-detail-popup ref="detailPopup" :selected-result-trigger="selectedResultTrigger"></w-execution-result-detail-popup>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { isEqual, isNil, map, isEmpty } from 'lodash';
import { getValueAfterCheckEmpty, EMPTY_TEXT } from '@/utils/string';
import { getDateToString } from '@/utils/date';
import { columnDefault, defaultDetailHeaderColumn } from '@/constants/table';
import AmsResultAPI from '@/api/ams/result';
import FileApi from '@/api/common/file';
import WExecutionResultDetailPopup from '../popup/ExecutionResultDetailPopup';
// import msgUtil from '@/utils/message';
const defaultFormatter = (row, column, value) => getValueAfterCheckEmpty(value);

export default {
  name: 'WTriggerResultTable',
  components: {
    WExecutionResultDetailPopup,
  },
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    filterList: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    ...mapGetters(['analysisDateParams']),
  },
  data() {
    return {
      colorObject: {
        성공: 'rgb(86, 139, 210)',
        부분성공: 'rgb(247, 186, 0)',
        실패: 'rgb(253, 116, 132)',
      },
      changeFlagColorObject: {
        true: '',
        false: 'rgb(216, 216, 216)',
      },
      columnDefault,
      total: 0,
      showSearchTool: false,
      tableColumns: [
        {
          prop: 'resultStatus',
          label: '상태',
          width: '90px',
          filters: [
            {
              text: '성공',
              value: '성공',
            },
            {
              text: '부분성공',
              value: '부분성공',
            },
            {
              text: '실패',
              value: '실패',
            },
          ],
          scopedSlot: 'result-slot',
          // formatter: this.getResultFlagName,
        },
        {
          prop: 'triggerName',
          label: '템플릿 이름',
          searchable: true,
          formatter: defaultFormatter,
        },
        {
          prop: 'triggerDesc',
          label: '템플릿 설명',
          searchable: true,
          formatter: defaultFormatter,
        },
        {
          prop: 'triggerExecTypeId',
          label: '수행 타입',
          width: '90px',
          formatter: this.getTriggerExecTypeName,
          filters: [
            {
              text: '직접수행',
              value: 'DIRECT',
            },
            {
              text: '스케쥴',
              value: 'SCHEDULE',
            },
          ],
        },
        {
          prop: 'executorId',
          label: '수행자',
          searchable: true,
          width: '120px',
        },
        {
          prop: 'startDatetime',
          label: '수행시작시각',
          width: '140px',
          formatter: this.getDateFormatter,
        },
        {
          prop: 'endDatetime',
          label: '수행종료시각',
          width: '140px',
          formatter: this.getDateFormatter,
        },
        {
          prop: 'resultDetail',
          label: '작업 수행 결과',
          width: '110px',
        },
        {
          prop: 'changeFlag',
          label: '변경',
          width: '80px',
          filters: [
            {
              text: '변경',
              value: '1',
            },
            {
              text: '미변경',
              value: '0',
            },
          ],
          scopedSlot: 'change-slot',
          // formatter: this.getStatusFlagName,
        },
        {
          ...defaultDetailHeaderColumn,
          scopedSlot: 'detail-slot',
        },
      ],
      tableData: [],
      checkedRows: [],
      selectedResultTrigger: null,
    };
  },
  watch: {
    active: {
      handler(value) {
        if (!isNil(value) && value) {
          if (isEmpty(this.filterList)) {
            this.$nextTick(() => {
              this.loadData();
            });
          }
        }
      },
      immediate: true,
    },
    analysisDateParams() {
      this.loadData();
    },
    filterList() {
      this.loadData();
    },
  },
  methods: {
    loadData() {
      if (!this.active) {
        return;
      }
      const resultStatusFilters = this.filterList.filter((item) => isEqual(item.type, 'resultStatus'));
      const triggerFilters = this.filterList.filter((item) => isEqual(item.type, 'triggerList'));
      const tableParams = this.$refs.table.getParameter();
      this.$emit('get-search-params', tableParams.searchParams);
      const params = {
        ...tableParams,
        startDatetime: this.analysisDateParams.startDatetime,
        endDatetime: this.analysisDateParams.endDatetime,
        resultStatusFilters: map(resultStatusFilters, 'label'),
        triggerFilters: map(triggerFilters, 'triggerId'),
      };
      AmsResultAPI.getTriggerExecutionResultList(params).then((response) => {
        const result = response.data;
        if (result.success) {
          this.total = result.total;
          this.tableData = result.data;
        }
      });
    },
    getDateFormatter(row, column, value) {
      if (!isNil(value)) {
        return getDateToString(value);
      }
      return EMPTY_TEXT;
    },
    onClickDetailButton(row) {
      this.selectedResultTrigger = row;
      this.$refs.detailPopup.open();
    },
    getTriggerExecTypeName(row, column, value) {
      if (isEqual(value, 'SCHEDULER')) return '스케쥴';
      return '직접수행';
    },
    /**
     * 엑셀출력 버튼 click
     * @author jeee12
     * @return {[type]} [description]
     */
    onClickExportExcel() {
      const resultStatusFilters = this.filterList.filter((item) => isEqual(item.type, 'resultStatus'));
      const triggerFilters = this.filterList.filter((item) => isEqual(item.type, 'triggerList'));
      const tableParams = this.$refs.table.getParameter();
      const params = {
        ...tableParams,
        startDatetime: this.analysisDateParams.startDatetime,
        endDatetime: this.analysisDateParams.endDatetime,
        resultStatusFilters: map(resultStatusFilters, 'label'),
        triggerFilters: map(triggerFilters, 'triggerId'),
      };

      AmsResultAPI.exportTriggerExecRsltListExcel(params).then((response) => {
        if (response.data.success && response.data.data) {
          FileApi.downloadExportedExcelFile(response.data.data);
        }
      }).catch(() => {});
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/work/popup/components/ExecutionResult/components/TriggerResultTable.vue